export enum enAnnouncementsType {
  INFORMATIVE = 'INFORMATIVE',
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
  WARNING = 'WARNING'
}

export interface ITextAnnouncement {
  text: string;
  type: enAnnouncementsType;
  title?: string;
}

export interface IBannerAnnouncement {
  large: string;
  alternative: string;
  short: string;
  medium?: string;
  link?: string;
}

export interface IAnnouncement {
  id: string;
  expirationDate: Date;
  order?: number;
  active?: boolean;
  onlyUnity?: boolean;
  belt?: enBelts;
  alert?: ITextAnnouncement;
  banner?: IBannerAnnouncement;
}

export enum enBelts {
  WHITE = 'WHITE',
  RED = 'RED',
  ORANGE = 'ORANGE',
  GREEN = 'GREEN',
  BLACK = 'BLACK',
  GOLDEN = 'GOLDEN'
}
